import "@patternslib/dev/webpack/module_federation";

// Webpack entry point for module federation.
import("./bundle");
